import React from 'react'

const AccountEditTitle = ({ record }) => (
  <span>{record ? `${record.name}` : ''}</span>
)

export default AccountEditTitle
